<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Kỳ thi</h2>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-exam-list"
          hide-details
          :label="'Cho phép ' + roleName + ' xem kỳ thi'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-admin-exam"
          hide-details
          :label="'Cho phép ' + roleName + ' thiết lập kỳ thi'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="input-exam-mark"
          hide-details
          :label="'Cho phép ' + roleName + ' nhập điểm thi'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-subject-mark-teacher"
          hide-details
          :label="'Cho phép ' + roleName + ' xem điểm lớp dạy'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-mark-head-teacher"
          hide-details
          :label="'Cho phép ' + roleName + ' xem điểm lớp chủ nhiệm'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>

<style scoped></style>
